import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { BcTagComponent } from '@bancolombia/design-system-web/bc-tag';
import { BcModalComponent } from '@bancolombia/design-system-web/bc-modal';

import { BCTagModel } from 'src/app/domain/models/factura-estado/bc-tag.model';
import { FacturaContentModel } from 'src/app/domain/models/factura/factura.model';
import { FacturaEstadoUseCase } from 'src/app/domain/usecases/factura-estado/factura-estado.usecase';
import { CausalRechazoUseCase } from 'src/app/domain/usecases/causal-rechazo/causal-rechazo.usecase';
import { CausalRechazoModel } from 'src/app/domain/models/causal-rechazo/causal-rechazo.model';
import { FacturaUseCase } from 'src/app/domain/usecases/factura/factura.usecase';
import { FacturaCambioEstadoModel } from 'src/app/domain/models/factura/factura-cambio-estado.model';
import { AzureAdAccountModel } from 'src/app/domain/models/azure-ad/account.model';
import { Observable } from 'rxjs';
import { Store } from '@ngxs/store';
import { BcCircleLoadingComponent } from '@bancolombia/design-system-web/bc-circle-loading';
import { CambioEstadoRequestModel } from 'src/app/domain/models/cambio-estado/cambio-estado-request.model';
import { AppModalUseCase } from 'src/app/domain/usecases/app-modal/app-modal.usecase';

@Component({
  selector: 'app-btn-cambio-estado',
  templateUrl: './btn-cambio-estado.component.html',
  styleUrls: ['./btn-cambio-estado.component.css']
})
export class BtnCambioEstadoComponent implements OnInit {

  /* Modal */
  isModal: boolean = false;
  titleModal: string = ''
  typeIconModal: any = 'error'
  bodyModal: string = ''
  subBodyModal: string = ''
  /* End Modal */

  @Input('dataFactura') dataFactura: FacturaContentModel;

  @Input('loading') bcCircleLoading!: BcCircleLoadingComponent;

  @ViewChild('rechazado', { static: false })
  bcModalComponent!: BcModalComponent;

  @ViewChild('confirmacion', { static: false })
  bcModalComponentDos!: BcModalComponent;

  @ViewChild('btnEstados', { static: false })
  bcTagBtn!: BcTagComponent;

  bandera: boolean;

  title: string = 'Causal de rechazo';

  typeIcon: 'error' | 'success' | 'warning' | 'info' | 'default';

  customWidth: 'small' | 'medium' | 'large';

  subBody: string;

  causalesRechadoList: Array<{
    label: string;
    value: any;
  }>;

  causalesRechazo: CausalRechazoModel[];

  estadosList: BCTagModel[];

  bodyRequest: FacturaCambioEstadoModel;

  formCausalesRechazo: FormGroup;

  // modal Confirmacion
  confirmAction: boolean = true;
  confirmDisplayButton: boolean = true;
  confirmOuterCloseTap: boolean = true;
  confirmSubTitle = 'Realmente desea cambiar el estado de la factura?';
  confirmButtonAlignment: any = 'horizontal';
  //fin modal Confirmacion

  nuevoEstadoConfirm = {
    'value': ''
  }

  azureAccount: Observable<AzureAdAccountModel>;

  username: string;

  //Usuario del sistema por defecto cuando no hay una autenticacion con Azure AD
  nombreTest = 'system';


  refrescarBtnEstados:boolean = true;

  constructor(
    private fb: FormBuilder,
    private facturaEstadoUseCase: FacturaEstadoUseCase,
    private causalRechazoUseCase: CausalRechazoUseCase,
    private facturaUseCase: FacturaUseCase,
    private store: Store,
    private appModalUseCase: AppModalUseCase) {
    //Declaracion de variables
    this.typeIcon = 'error';
    this.customWidth = 'large';
    this.subBody = '';
    this.causalesRechadoList = [];
    this.causalesRechazo = [];
    this.bandera = false;

    this.dataFactura = {
      numero_factura: '',
      ciudad: null,
      remitente: '',
      nit: '',
      fecha_creacion: new Date(),
      estado: {
        nombre: '',
        codigo: ''
      },
      retieca: '',
      reteiva: '',
      retefuente: '',
      total_acticipos: 0,
      iva: '',
      total_antes_impuestos: 0,
      total_incl_impuestos: 0,
      razons_adquiriente:'',
      nit_adquiriente:'',
      ciuAdquiriente: '',
      depEmision:''
    };

    this.estadosList = [
      {
        spanText: '',
        value: '',
        iconName: '',
      },
    ]

    this.bodyRequest = {
      numero: '',
      estado: '',
      usuario: '',
      causalRechazo: ''
    };

    this.formCausalesRechazo = this.fb.group({
      causalRechazo: ['', [Validators.required]]
    })

    //Obtiene informacion de la Store
    this.azureAccount = this.store.select(state => state.account);

    this.username = '';
    //END Declaracion de variables
  }

  ngOnInit() {
    this.estadosList = this.facturaEstadoUseCase.getUsuarioEstadoSessionStorage();
    this.obtenerAzureAccountUsername();
  }

  ngAfterViewInit() {
    this.consultarCausalesRechazo();
  }  

  obtenerAzureAccountUsername(): void {
    this.azureAccount.subscribe({
      next: data => {
        this.username = data.username == null ? this.nombreTest : data.username!;
      }
    });
  }

  consultarCausalesRechazo() {
    this.isModal = false;
    this.causalRechazoUseCase.findAll()
      .subscribe({
        next: (data: CausalRechazoModel[]) => {          
          this.causalesRechadoList = this.construirCausalRechazoModel(data);
        },
        error: () => {
          this.isModal = true;
          this.modalFindErrorMessages();
        }
      });
  }

  construirCausalRechazoModel(data: CausalRechazoModel[]) {
    return data.map((dataMap: CausalRechazoModel) => {
      return {
        label: dataMap.nombre,
        value: dataMap.codigo
      }
    });
  }

  seleccionarEstado(evento: any): void {
    //Si seleccionan rechazar factura
    const { value } = evento;
    if (value === 'R') {
      //Despliega modal rechazados      
      this.bcModalComponent.openModal();
      //Si el estado es diferente al estado actual de la factura
    }else{
      this.nuevoEstadoConfirm.value = value;
      this.bcModalComponentDos.openModal();
    }      
    
  }

  cambiarEstadoRequest(estado: string, causalRechazo: string = ''): void {
    this.bcCircleLoading.showCircleLoading();
    this.isModal = false;
    this.refrescarBtnEstados = false;
    this.facturaUseCase.cambiarEstado(this.construirBodyRequest(estado, causalRechazo))
      .subscribe({
        next: (data) => {          
          this.refrescarBtnEstados = true;
          this.bcCircleLoading.hideCircleLoading();
          this.facturaUseCase.openAlert('success', '', '¡La factura fue cambiada de estado exitosamente!', 5000);
          
          this.dataFactura.estado.nombre = data.estado.nombre;
          this.dataFactura.estado.codigo = data.estado.codigo;
          
          if (data.estado.codigo === 'A' || data.estado.codigo === 'R') {
            //Deshabilita el boton de cambios de estado
            this.bcTagBtn.status = 'disabled';
          }
        },
        error: (data) => {              
          this.bcCircleLoading.hideCircleLoading();
          this.isModal = true;
          this.refrescarBtnEstados = true;
          if(data.status != 400){
            this.modalFindErrorMessages();
          }else{
            this.bodyModal = `[${data.status}] ${data.error.message[0]}`;
          }                              
        }
      });
  }

  validarFormulario(): void {
    if (this.formCausalesRechazo.invalid) {
      this.formCausalesRechazo.markAllAsTouched();
      return;
    }

    const { causalRechazo } = this.formCausalesRechazo.getRawValue();

    this.cambiarEstadoRequest('R', causalRechazo);

    this.bcModalComponent.shutDown();
  }

  construirBodyRequest(estado: string, causalRechazo: string = ''): FacturaCambioEstadoModel {

    let payload: CambioEstadoRequestModel = {
      numero: this.dataFactura!.numero_factura,
      estado: estado,
      usuario: this.username,
    };

    if (causalRechazo.length > 0) {
      payload.causalRechazo = causalRechazo;
    }

    return payload;
  }

  //Comprueba si el componente Tag esta habilitado o deshabilitado
  //Estados Aprobado y Rechazado boton deshabilitado
  isTagDisabled(estado: string): 'disabled' | 'selected' {
    return estado === 'A' || estado === 'R' ? 'disabled' : 'selected';
  }

  // Modal Confirmacion cambio de estado si/no
  onPressButton(event: any) {
    switch (Number(event)) {
      case 0: {
        this.bcModalComponentDos.shutDown();
      }
        break;
      case 1: {
        this.bcModalComponentDos.shutDown();
        this.cambiarEstadoRequest(this.nuevoEstadoConfirm.value);
      }
        break;
    }
  }

  modalFindErrorMessages(): void {
    const [titleModal, typeIconModal, bodyModal, subBodyModal] = this.appModalUseCase.modalFindErrorMessages();
    this.titleModal = titleModal;
    this.typeIconModal = typeIconModal;
    this.bodyModal = bodyModal;
    this.subBodyModal = subBodyModal;
  }

}
